import * as S from "../Cadastro/styles";

function App() {

    return (
        <S.Container>
            <section className="regulation py-1">
                <div className="content content--xx-large">
                    <h1 data-aos="flip-up" data-aos-duration="900">
                        Política de privacidade
                    </h1>
                </div>

                <div className="contentRegulation pt-1">
                    <div className="regulation__container rules-stamp">
                        <div className="regulation__content secondary-background">
                            <p>
                                <h2>AVISO DE PRIVACIDADE</h2>
                            </p>

                            <p>
                                <h4>Identificação</h4>
                            </p>

                            <p>
                                A <b>COOPERATIVA VINÍCOLA AURORA LTDA.</b>, inscrita no CNPJ sob
                                nº 87.547.188/0001-70, com sede na Rua Olavo Bilac, nº 500, Bairro
                                Cidade Alta, na cidade de Bento Gonçalves/RS, é a responsável por
                                definir os motivos pelos quais os seus dados pessoais serão
                                utilizados.
                            </p>

                            <p>
                                Este documento informará os direitos dos titulares e as nossas
                                obrigações, além de explicar como, para quê e quando os dados
                                pessoais serão utilizados por nós para a promoção “
                                <b>De Malas Prontas com Marcus James</b>”.
                            </p>

                            <p>
                                <h4>Dados utilizados e para quais finalidades</h4>
                            </p>

                            <p>
                                Não coletaremos dados pessoais desnecessários e utilizaremos os
                                dados pessoais conforme especificado no resumo abaixo:
                            </p>

                            <p>
                                Dados Pessoais Utilizados: Nome, CPF, RG, endereço, telefone,
                                e-mail, histórico de compras, número da sorte;
                            </p>

                            <p>
                                Finalidades: 1) Possibilitar a inscrição do interessado na
                                promoção “<b>De Malas Prontas com Marcus James</b>”; 2) Permitir o
                                cadastramento dos produtos adquiridos pelo participante; 3)
                                Emitir os números da sorte aos participantes da promoção; 4)
                                Efetuar o sorteio dos prêmios; 5) Publicar o resultado dos
                                vencedores na página oficial da promoção; 6) Emitir o voucher aos
                                vencedores da promoção; 7) Contatar os participantes acerca da
                                promoção através de e-mail, telefone e/ou whatsapp; 8) Enviar
                                comunicações oficiais relacionadas com a promoção através de
                                e-mail, telefone e/ou whatsapp.
                            </p>

                            <p>
                                Fundamento Legal: Os dados pessoais serão coletados e utilizados
                                para fins de execução do regulamento da promoção (que se
                                caracteriza como contrato entre as partes), nos termos do art.
                                7º, inciso V da Lei 13.709/2018.
                            </p>

                            <p>
                                <h4>Forma e duração da utilização dos seus dados</h4>
                            </p>

                            <p>
                                Os dados pessoais indicados neste Aviso serão coletados através do
                                formulário digital disponibilizado no site oficial da promoção{" "}
                                <a href="http://www.marcusjames.com.br/promocao">
                                    <b>www.marcusjames.com.br/promocao</b>
                                </a>
                                . Em relação aos vencedores, publicaremos a relação no site da
                                promoção pelo prazo de 30 (trinta) dias. Além disso, utilizaremos
                                os dados pessoais dos vencedores para a emissão dos prêmios
                                (vouchers).
                            </p>

                            <p>
                                Manteremos os dados pessoais durante o período necessário para o
                                atendimento das finalidades indicadas neste Aviso, sendo que,
                                após o encerramento da promoção e a entrega efetiva das
                                premiações, descartaremos os dados pessoais coletados, exceto
                                aqueles que a conservação é necessária para atender obrigações
                                legais e/ou para possibilitar o exercício de direitos em processo
                                judicial, administrativo e/ou arbitral.
                            </p>

                            <p>
                                <h4>Sobre o compartilhamento dos dados pessoais</h4>
                            </p>

                            <p>
                                Os dados pessoais coletados serão compartilhados apenas com as
                                pessoas essenciais ao desenvolvimento da promoção “
                                <b>De Malas Prontas com Marcus James</b>”, ou seja <b>(i)</b> com
                                a agência de publicidade “<b>8poroito</b>” responsável pela gestão
                                do site da promoção; <b>(ii)</b> com a agência de viagens “
                                <b>CVC</b>” para possibilitar a emissão dos vouchers aos vencedores
                                da promoção; <b>(iii)</b> com o provedor de serviço de correio
                                eletrônico (e-mail) e e-mail marketing para envio de comunicações
                                oficiais sobre a promoção; e <b>(iv)</b> com os colaboradores dos
                                nossos setores envolvidos no desenvolvimento da promoção.
                            </p>

                            <p>
                                Os nossos colaboradores e parceiros estão contratualmente
                                obrigados a adotar padrões de segurança no uso dos dados pessoais
                                de acordo com a Lei Geral de Proteção de Dados Pessoais (LGPD),
                                com o objetivo de garantir a segurança física e digital dos dados
                                pessoais, bem como sua privacidade.
                            </p>

                            <p>
                                <h4>Direitos dos titulares</h4>
                            </p>

                            <p>
                                A Lei Geral de Proteção de Dados Pessoais (LGPD) garante uma série
                                de direitos sobre os dados pessoais. Eles podem ser exercidos
                                encaminhando uma mensagem para{" "}
                                <a href="mailto:privacidade@vinicolaaurora.com.br">
                                    <b>privacidade@vinicolaaurora.com.br</b>
                                </a>
                                <b>.</b>
                            </p>

                            <p>De acordo com a lei, é possível:</p>

                            <p>· Confirmar a existência de uso dos dados pessoais;</p>

                            <p>
                                · Acessar os dados pessoais utilizados, caso eles estejam sendo
                                usados;
                            </p>

                            <p>
                                · Corrigir dados pessoais incompletos, incorretos ou desatualizados;
                            </p>

                            <p>
                                · Anonimizar (impedir a identificação através do dado pessoal),
                                bloquear ou eliminar os dados desnecessários, excessivos ou
                                utilizados em desacordo com a lei;
                            </p>

                            <p>· Obter informações sobre o compartilhamento dos dados com terceiros;</p>

                            <p>· Se opor aos tratamentos de dados pessoais realizados; e/ou</p>

                            <p>
                                · Nos casos em que não atendermos adequadamente suas solicitações,
                                registrar reclamação perante a Autoridade Nacional de Proteção de
                                Dados – ANPD.
                            </p>

                            <p>
                                Se recebermos uma solicitação sua para exercer qualquer um dos
                                direitos acima, podemos pedir que você confirme sua identidade
                                antes de atendermos a solicitação, com o objetivo de garantir que
                                seus dados se mantenham protegidos em segurança.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </S.Container>
    );
}

export default App;